import { render, staticRenderFns } from "./CertificadorBHPPantalla.vue?vue&type=template&id=6d978882&"
import script from "./CertificadorBHPPantalla.vue?vue&type=script&lang=ts&"
export * from "./CertificadorBHPPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports